// TODO: (vivian) this component is existed in lib, remove and use the one from lib after release
import styles from './DonutChart.module.css';

type DonutChartProps = {
  ringWidth: number;
  ringColor: string;
  ringBgColor: string;
  currentValue: number;
  text: string;
};

const DonutChart = ({
  ringWidth,
  ringColor,
  ringBgColor,
  currentValue,
  text,
}: DonutChartProps) => {
  const radius = 50 - ringWidth / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = Math.max(
    circumference - (currentValue / 100) * circumference,
    0
  );

  const ringStyle: any = {
    '--offset': offset,
    '--circumference': circumference,
  };

  return (
    <svg
      viewBox="0 0 100 100"
      className={styles['donut-chart']}
      data-testid="donut-chart-svg"
    >
      <circle
        className={styles['donut-chart-ring-bg']}
        cx="50"
        cy="50"
        r={radius}
        strokeWidth={ringWidth}
        stroke={ringBgColor}
        fill="transparent"
        data-testid="donut-chart-bg"
      />
      <circle
        className={styles['donut-chart-ring']}
        cx="50"
        cy="50"
        r={radius}
        strokeWidth={ringWidth}
        stroke={ringColor}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        style={ringStyle}
        fill="transparent"
        data-testid="donut-chart-ring"
      />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dy=".4em"
        className={styles['donut-chart-text']}
        fill={ringColor}
        data-testid="donut-chart-text"
      >
        {text}
      </text>
    </svg>
  );
};

export default DonutChart;
